<div class="d-flex flex-row">
    <div class="d-flex flex-column login-component justify-content-between" 
        style="gap: 30px;width: 550px;margin-bottom: 0;">
        <div>
            <h3>Logowanie</h3>
            <form ngForm #authForm="ngForm" (ngSubmit)="onSubmit(authForm)">
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-label>E-mail</mat-label>
                    <input matInput type="email" placeholder="Login" required [errorStateMatcher]="matcher"
                        [formControl]="emailFormControl">
                    @if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
                    <mat-error>Podany adres e-mail jest nieprawidłowy</mat-error>
                    }
                    @if (emailFormControl.hasError('required')) {
                    <mat-error>Proszę wprowadzić e-mail</mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-label>Hasło</mat-label>
                    <input matInput type="password" [errorStateMatcher]="matcher" placeholder="Hasło"
                        [formControl]="passwordFormControl" required>
                    @if (passwordFormControl.hasError('required')) {
                    <mat-error>Proszę wprowadzić hasło</mat-error>
                    }
                    @if (passwordFormControl.hasError('minlength')) {
                    <mat-error>Długość hasła to minimum 6 znaków</mat-error>
                    }
                </mat-form-field>
                @if (error.length) {
                <mat-error *ngIf="error.length">
                    {{ error }}
                </mat-error>
                }
                <div class="d-flex flex-row justify-content-between align-items-center">
                    <mat-checkbox [formControl]="rememberMe">zapamiętaj mnie</mat-checkbox>
                    <a class="underline-link" (click)="router.navigate(['forgot-password'])">Zapomniałem hasła</a>
                </div>

                <div class="button">
                    <button style="width:100%;" type="submit" mat-flat-button color="tertiary" appearance="outline"
                        [disabled]="!emailFormControl.valid || !passwordFormControl.valid">Zaloguj</button>
                </div>
            </form>
        </div>
        <!-- a (click)="router.navigate(['register'])">Zarejestruj się</a -->
        <app-social-media></app-social-media>
    </div>
    <div class="d-flex align-items-stretch rekbot-img flex-grow-1 mt-0 me-0"></div>
</div>